import { render, staticRenderFns } from "./SlcShortcuts.vue?vue&type=template&id=ba7c8f96&"
import script from "./SlcShortcuts.vue?vue&type=script&lang=ts&"
export * from "./SlcShortcuts.vue?vue&type=script&lang=ts&"
import style0 from "./SlcShortcuts.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle})
